import { Loader2 } from "lucide-react";

export function FullPageLoading({ label }: { label: string }) {
  return (
    <main className="grid min-h-screen place-items-center bg-radial-[circle_at_top] from-accent-glow to-background to-48%">
      <Loader2 className="animate-spin" />
      <p className="mb-4">{label}</p>
    </main>
  );
}
